module.exports = {"scale":32,"platforms":[{"message":"starting platform","type":"FiniteImmobilePlatform","x":3,"y":14,"width":18,"height":5,"display":{"assetName":"temple"}},{"message":"goal platform","type":"FiniteImmobilePlatform","x":12,"y":11,"width":7,"height":3,"display":{"assetName":"temple"}}],"goal":{"x":14,"y":11},"player":{"x":5,"y":11}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/json-loader!./levels/beta-1-tutorial.json
// module id = 138
// module chunks = 0